export const BUSINESS_TRAVELLER_ROOT_ROUTE = '/'

// Login (dedicated app/mobile login page)
export const BUSINESS_TRAVELLER_LOGIN_ROUTE = '/login'

// Business signup
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE = '/business-signup'
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE = '/business-signup-complete'
// Employee setup
export const BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE = '/employee-setup'
// Order Approval Page
export const BUSINESS_TRAVELLER_APPROVE_ORDER_ROUTE = '/approve-order/:approveRequestId'
export const BUSINESS_TRAVELLER_FAQ_ROUTE = '/frequently-asked-questions'
export const BUSINESS_TRAVELLER_EXPRESSION_OF_INTEREST_ROUTE = '/expression-of-interest'

// My Approvals Page
export const BUSINESS_TRAVELLER_MY_APPROVALS_ROUTE = '/my-approvals'
export const BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE = '/my-approvals/pending'
export const BUSINESS_TRAVELLER_MY_APPROVALS_HISTORY_ROUTE = '/my-approvals/history'

export const BUSINESS_TRAVELLER_MY_APPROVALS_VIEW_ROUTE = '/my-approvals'

// My Trip Requests Page
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ROUTE = '/my-trip-requests'
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ACTIVE_ROUTE = '/my-trip-requests/active'
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_HISTORY_ROUTE = '/my-trip-requests/history'

export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_VIEW_ROUTE = '/my-trip-requests'

// Policy page
export const BUSINESS_TRAVELLER_POLICY_ROUTE = '/privacy-policy'

// Booking & refund policy page
export const BUSINESS_TRAVELLER_BOOKING_POLICIES_ROUTE = '/booking-policies'

// Terms and conditions page
export const BUSINESS_TRAVELLER_TERMS_AND_CONDITIONS_ROUTE = '/terms-and-conditions'

export const BUSINESS_TRAVELLER_SUPPORT_HEADER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE}`,
]

export const BUSINESS_TRAVELLER_SALES_LANDING_ROUTE = '/:regionCode'

export const BUSINESS_TRAVELLER_NO_HEADER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_LOGIN_ROUTE}`,
]

export const BUSINESS_TRAVELLER_NO_FOOTER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_LOGIN_ROUTE}`,
]

export const MOBILE_APP_NO_HEADER_ROUTES_LOGOUT = [
  `/:regionCode${BUSINESS_TRAVELLER_POLICY_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_BOOKING_POLICIES_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_TERMS_AND_CONDITIONS_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_FAQ_ROUTE}`,
]
